import { render, staticRenderFns } from "./integralrulelist.vue?vue&type=template&id=39060ef1&"
import script from "./integralrulelist.vue?vue&type=script&lang=js&"
export * from "./integralrulelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports